import {get} from 'utils/axios/cms/index'
import {
 IApiResponse,
 IHelpMenu,
 IPublicMenu,
 IUserModule,
 IUserSubModule,
} from 'models/CMS'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import {IFormField} from 'models/Common'
import qs from 'qs'
import {getAccessValue} from 'utils/helper'

export const fetchUserMenu = async (
 userCategoryKey: string,
 selectedLanguage?: string
) => {
 try {
  const query = qs.stringify(
   {
    filters: {
     user_categories: {
      DehaatUserCategoryKey: {
       $eq: userCategoryKey,
      },
     },
    },
    pagination: {
     page: 1,
     pageSize: 99999,
    },
    locale: selectedLanguage ?? 'en',
    sort: 'DisplayOrder, id',
    fields: ['Label', 'Url'],
   },
   {
    encodeValuesOnly: true, // prettify URL
   }
  )
  const menuRes = await get<IApiResponse<IPublicMenu>>(
   `/user-menus?${query}`
  )
  const menuArr = []
  if (menuRes?.data) {
   for (const menu of menuRes.data) {
    menuArr.push({...menu})
   }
  }

  return menuArr
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

export const fetchUserConfig = async (
 userCategoryKey: string
) => {
 try {
  const reqPayload = {
   userCategoryKey,
  }

  const userModuleQuery = qs.stringify(
   {
    filters: {
     $and: [
      {
       Access: {
        user_categories: {
         DehaatUserCategoryKey: {
          $eq: userCategoryKey,
         },
        },
       },
      },
     ],
    },
    pagination: {
     page: 1,
     pageSize: 99999,
    },
    sort: 'id',
    fields: ['Label', 'Url', 'KeyName'],
   },
   {
    encodeValuesOnly: true, // prettify URL
   }
  )

  const userModuleRes = await get<
   IApiResponse<IUserModule>
  >(`/user-modules?${userModuleQuery}`)
  const userModuleArr: IFormField = {}
  const routes = []
  if (userModuleRes?.data) {
   for (const userModule of userModuleRes.data) {
    routes.push(userModule?.Url)
    userModuleArr[userModule?.KeyName] = {
     ...userModule,
    }
   }
  }

  const userSubModuleQuery = qs.stringify(
   {
    populate: {
     user_module: {
      fields: 'KeyName',
     },
     Sections: {
      populate: {
       ViewAccess: {
        populate: {
         user_categories: {
          fields:
           'DehaatUserCategoryId,DehaatUserCategoryKey',
         },
        },
       },
       EditAccess: {
        populate: {
         user_categories: {
          fields:
           'DehaatUserCategoryId,DehaatUserCategoryKey',
         },
        },
       },
       AddAccess: {
        populate: {
         user_categories: {
          fields:
           'DehaatUserCategoryId,DehaatUserCategoryKey',
         },
        },
       },
      },
     },
    },
    pagination: {
     page: 1,
     pageSize: 99999,
    },
    filters: {
     $and: [
      {
       SubModuleAccess: {
        user_categories: {
         DehaatUserCategoryKey: {
          $eq: userCategoryKey,
         },
        },
       },
      },
     ],
    },
    fields: ['Label', 'KeyName'],
    sort: ['id:desc'],
   },
   {
    encodeValuesOnly: true, // prettify URL
   }
  )

  const userSubModuleRes = await get<
   IApiResponse<IUserSubModule>
  >(`/user-sub-modules?${userSubModuleQuery}`)

  const sectionArr: IFormField = {}
  if (userSubModuleRes?.data) {
   for (const userSubModule of userSubModuleRes.data) {
    const userModuleKey = userSubModule?.user_module.KeyName

    const parentSection = {
     name: userSubModule?.Label,
     key: userSubModule?.KeyName,
     section: {},
    }
    const subSectionArr: IFormField = {}
    for (const val of userSubModule?.Sections) {
     const section = {
      subSectionName: val?.SectionName,
      subSectionKey: val?.SectionKey,
      canView: false,
      canEdit: false,
      canAdd: false,
     }
     section.canView = getAccessValue(
      val?.ViewAccess,
      reqPayload
     )
     section.canEdit = getAccessValue(
      val?.EditAccess,
      reqPayload
     )
     section.canAdd = getAccessValue(
      val?.AddAccess,
      reqPayload
     )
     subSectionArr[val?.SectionKey] = {...section}
    }
    parentSection.section = subSectionArr
    if (userModuleKey) {
     if (!sectionArr[userModuleKey]) {
      sectionArr[userModuleKey] = {}
     }
     sectionArr[userModuleKey][userSubModule?.KeyName] =
      parentSection
    }
   }
  }

  return {
   routes,
   userModule: userModuleArr,
   userSubModule: sectionArr,
  }
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

export const fetchHelpSectionMenu = async (
 userCategoryKey: string,
 selectedLanguage?: string
) => {
 try {
  const query = qs.stringify(
   {
    filters: {
     $and: [
      {
       AccessLevel: {
        user_categories: {
         DehaatUserCategoryKey: {
          $eq: userCategoryKey,
         },
        },
       },
      },
     ],
    },
    populate: {
     Icon: true,
    },
    pagination: {
     page: 1,
     pageSize: 99999,
    },
    locale: selectedLanguage ?? 'en',
    sort: 'DisplayOrder, id',
    fields: ['*'],
   },
   {
    encodeValuesOnly: true, // prettify URL
   }
  )
  const res = await get<IApiResponse<IHelpMenu>>(
   `/help-menus?${query}`
  )
  if (res?.data) {
   return res.data
  }

  return null
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}
